import {inject, Injectable} from '@angular/core';
import {DownloadPackagesExcelApiService} from "./download-packages-excel-api.service";
import {ProgressStatus} from "../../../../../../core/types/upload-progress.types";
import {HttpEvent, HttpEventType} from "@angular/common/http";
import {UploadProgressService} from "../../../../../../core/services/upload-progress.service";
import {ErrorService} from "../../../../../../core/services/error.service";
import {FilesService} from "../../../../../../core/services/files.service";

@Injectable({
  providedIn: 'root'
})
export class DownloadPackagesExcelService {
  private downloadPackagesExcelApiService: DownloadPackagesExcelApiService = inject(DownloadPackagesExcelApiService);
  private uploadProgressService: UploadProgressService = inject(UploadProgressService);
  private errorService: ErrorService = inject(ErrorService);
  private filesService: FilesService = inject(FilesService);

  public downloadPackagesExcel(fileName: string): Promise<void>  {
    return new Promise((resolve, reject) => {
      this.downloadPackagesExcelApiService.downloadPackagesExcel().subscribe({
        next: (event) => {
          const progress = this.handleDownloadEvent(event, fileName);
          this.uploadProgressService.updateProgress({
            progress: progress.progress,
            completed: progress.completed,
            fileName: fileName,
            fileType: 'file'
          });
        },
        error: (error) => {
          this.errorService.handleError(error);
          this.uploadProgressService.resetProgress();
          reject(error);
        },
        complete: () => {
          setTimeout(() => {
            this.uploadProgressService.resetProgress();
            resolve();
          }, 300);
        }
      });
    });
  }

  private handleDownloadEvent(event: HttpEvent<Blob>, fileName: string): ProgressStatus {
    switch (event.type) {
      case HttpEventType.DownloadProgress:
        return {
          progress: Math.min(99, Math.round(event.loaded / 100000)),
          completed: false
        };
      case HttpEventType.Response:
        const file = event.body as Blob;
        this.filesService.initiateFileDownload({ file, fileName: fileName });
        return { progress: 100, completed: true };
      default:
        return { progress: 0, completed: false };
    }
  }
}
